module.exports = __webpack_public_path__ + "static/media/main2.d9d9530c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/main2.jpg
// module id = 82
// module chunks = 0